import logoJeanie from 'assets/images/logo-jeanie.svg';

// ==============================|| LOGO ||============================== //

const Logo = () => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', lineHeight: 1 }}>
        <img src={logoJeanie} alt="Logo" style={{ width: '30px', height: '30px', display: 'block', flexShrink: 0 }} />
        <span style={{ fontSize: '19px', fontWeight: 700, letterSpacing: '-0.01em', color: '#20242B' }}>Jeanie</span>
    </span>
);

export default Logo;
